import { render, staticRenderFns } from "./skuSection.vue?vue&type=template&id=1df678fc&scoped=true&"
import script from "./skuSection.vue?vue&type=script&lang=ts&"
export * from "./skuSection.vue?vue&type=script&lang=ts&"
import style0 from "./skuSection.scss?vue&type=style&index=0&id=1df678fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df678fc",
  null
  
)

export default component.exports